import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../hooks/redux';
import { login, fetchMe } from '../store/slices/authSlice';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      const result = await dispatch(login(values)).unwrap();
      console.log('Login successful:', result);
      
      // Immediately fetch user info after login
      try {
        await dispatch(fetchMe()).unwrap();
        console.log('User info fetched successfully');
      } catch (fetchError: any) {
        console.warn('Failed to fetch user info, but login was successful:', fetchError);
        // Don't block navigation if fetchMe fails - token is valid
      }
      
      message.success('Login successful', 2);
      // Small delay to ensure message is visible before navigation
      setTimeout(() => {
        navigate('/dashboard');
      }, 500);
    } catch (error: any) {
      console.error('Login error:', error);
      // Extract error message from different possible error formats
      let errorMessage = 'Login failed, please check your email and password';
      const statusCode = error.response?.status;
      
      if (statusCode === 423) {
        // Account locked
        errorMessage = error.response?.data?.detail || 'Account has been locked, please try again later';
        message.error(errorMessage, 5); // Show longer for locked accounts
      } else {
        if (error.message) {
          errorMessage = error.message;
        } else if (error.response?.data?.detail) {
          errorMessage = error.response.data.detail;
        } else if (typeof error === 'string') {
          errorMessage = error;
        }
        message.error(errorMessage, 3);
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Card className="login-page-card">
        <h2 style={{ textAlign: 'center', marginBottom: 24 }}>
          GBP Review Analytics
        </h2>
        <Form name="login" onFinish={onFinish} autoComplete="off">
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Please enter your email' },
              { type: 'email', message: 'Please enter a valid email address' },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Email"
              size="large"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
